module.exports = __webpack_public_path__ + "static/media/attachment.20c03d1a.png";